import * as React from 'react'
import {Document, Page, Text, View} from '@react-pdf/renderer'
import { styles } from './styles';




export const ExamplePDF = ({number}) => { 
  
  
  
  return(
    
<Document>
    <Page size="A4" style={styles.page}>
      <View>
        <Text>Section #1</Text>
        <Text>Here is from the imported text: {number}</Text>
      </View>
      <View>
        <Text>Section #2</Text>
      </View>
    </Page>
  </Document>

)}